import { Button } from '@mantine/core'
import MapControlBox from './MapControlBox'
import { TbHome } from 'react-icons/tb'
import { modals } from '@mantine/modals'
import { Text } from '@mantine/core'
import { useTranslation } from 'react-i18next'

/**
 * On-map "go to garage" control.
 * When `active`, garage navigation is currently on and tapping confirms cancellation;
 * otherwise tapping confirms navigating to the garage. The actual action is supplied via `onConfirm`.
 */
const RefreshDirectionsToGarageButton = ({
  active = false,
  onConfirm,
}: {
  active?: boolean
  onConfirm: () => void
}) => {
  const { t } = useTranslation('navigation')

  const confirmationModal = () =>
    modals.openConfirmModal({
      title: (
        <Text size="xl" fw={700}>
          {t('goToGarageTitle')}
        </Text>
      ),
      children: (
        <Text size="xl" style={{ fontSize: 24, textAlign: 'center' }}>
          {active ? t('cancelGarageMessage') : t('goToGarageConfirmMessage')}
        </Text>
      ),
      labels: active
        ? { confirm: t('cancelGarageConfirm'), cancel: t('cancelGarageCancel') }
        : { confirm: t('goToGarageConfirm'), cancel: t('goToGarageCancel') },
      onCancel: () => {},
      onConfirm,
      size: 'lg',
      centered: true,
      styles: {
        title: { fontSize: 28, fontWeight: 'bold' },
        body: { fontSize: 24 },
      },
      zIndex: 10001,
    })

  return (
    <MapControlBox style={{ top: 90 }} position="left">
      <Button
        color={active ? 'blue' : 'gray'}
        variant="filled"
        onClick={e => {
          e.stopPropagation()
          confirmationModal()
        }}
        styles={{
          root: {
            height: 60,
            borderRadius: 64,
            padding: '0 10px',
            fontSize: 40,
          },
        }}
      >
        <TbHome />
      </Button>
    </MapControlBox>
  )
}

export default RefreshDirectionsToGarageButton
